// removed by extract-text-webpack-plugin
module.exports = {"container":"_3-1-JkefS_JibVR0bduRnF","nav":"_4nWT-_y91geV6OfjIy5__","picture":"_3QRW9MeBdGTeWmQyf7eHjX","blurb":"_2zrfYVCgVs2ME2fML89L8","title":"_3JqwPIKwM0hNDz6o5_RWbI","photo":"b7piX8DdYwIIBdWEf6-Dh"};


//////////////////
// WEBPACK FOOTER
// ./src/Header.css
// module id = 230
// module chunks = 0